import { create } from 'zustand';

const useLocationsStore = create((set) => ({
  // state
  has_variants: false,
  locations: [],
  heading: null,
  subHeading: null,

  // actions
  setHasVariants: (value) => set({ has_variants: value }),

  setLocations: (locations) => set({ locations }),

  setTexts: (heading, subHeading) => set({ heading, subHeading }),

  resetStore: () =>
    set({
      has_variants: false,
      locations: [],
    }),
}));

export default useLocationsStore;
